/**
 * Error object returned when `useFetch` encounters a response other than `ok` from a request.
 */
export default class HTTPError extends Error {
    constructor(response) {
        const code = response.status || response.status === 0 ? response.status : '';
        const title = response.statusText || '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}`);
        this.name = 'HTTPError';
        this.response = response;
    }
}
